import { render, staticRenderFns } from "./InstagramInstantwinPrizeMain.vue?vue&type=template&id=4bd9b1c6&scoped=true"
import script from "./InstagramInstantwinPrizeMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramInstantwinPrizeMain.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramInstantwinPrizeMain.vue?vue&type=style&index=0&id=4bd9b1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9b1c6",
  null
  
)

export default component.exports